module.exports = __webpack_public_path__ + "media/images/desktop/del-667bdc30cbbdc19ebc93a3519a396c83.png";